<template>
  <div style=" width: 80%;margin: 0 auto;padding-bottom: 50px;">
      <div class="account-add">
        <div class="account-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="old password：" prop="password">
              <Input type="text" v-model="formInline.password" placeholder="old password" />
            </FormItem>
            <FormItem label="new password：" prop="repassword">
              <Input type="text" v-model="formInline.repassword" placeholder="new password" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer" class="btns">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">save</Button>
        <!-- <Button @click="cancel">取消</Button> -->
      </div>
  </div>
</template>

<script>
import { validator } from "@/other/validator";
import { mapActions, mapGetters } from "vuex";

export default {
  // 修改密码
  name: "changePassword",
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInline.password) {
        callback(new Error("两次密码不匹配!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      showModal: false,
      formInline: {
        // form双向绑定
        password: "",
        repassword: ""
      }, 
      ruleInline: {
        // 效验规则
        password: [{ required: true, message: "Please enter password", trigger: "blur" }],
        repassword: [
          { required: true, message: "Please enter password", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const regex = /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*\d)(?=.*[\W_])|(?=.*[A-Z])(?=.*\d)(?=.*[\W_])).{8,}$/;
              if (!value) {
                callback("Please enter password");
              } else if (regex.test(value)) {
                callback();
              } else {
                callback("Passwords should be more than 8 characters long and contain at least two combinations of uppercase and lowercase letters, numbers, symbols, etc.");
              }
            },
            trigger: "blur"
          }
        ],
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo"
    })
  },
  created() {},
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId",
      changePasswordByOld: "loginModule/changePasswordByOld"
    }),
    async init() {
      let arr = [];
      let staffArr = await this.getStaffByCompId(this.company.id);
      staffArr.forEach(c => {
        // if (c.roleId === 1) {
          this.adminInfo = c;
        // }
      });
    },
    async handleSubmit(name) {
      
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let formData = {
        UserId: this.user.id,
        JoinId: this.joinInfo.joinId,
        CurrentPassword: form.password,
        NewPassword: form.repassword
      };
      let bool = await this.changePasswordByOld(formData);
      if (bool && bool.errors && bool.errors[0]) {
        if (bool.errors[0].code === -1) {
          this.$Message.error("Wrong password");
          return;
        }
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.$emit("closed", form.repassword);
      
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      // this.showModal = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      // this.$emit("finish");
      // this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-message {
  z-index: 9999 !important; /* 提高 z-index 值 */
}
::v-deep .ivu-form-item-content{
  margin-left: 140px!important;
}
::v-deep .ivu-form .ivu-form-item-label{
  width: 140px!important;
}
.account-add {
  padding: 20px 0 40px 0;
  width: 100%;
  margin: 0 auto;
}
.btns{
  margin: 0 auto;
  display: flex;
  justify-content: center;
  button {
    padding: 0 20px;
    margin: 0 20px;
  }
}
</style>

